interface Rule {
  pattern: RegExp;
  replacement: string;
}

const singulars: Rule[] = [
  // Handle general "ies" endings
  { pattern: /(.*?)ies$/i, replacement: '$1y' },
  // Handle single 's' endings
  { pattern: /([^a])s$/i, replacement: '$1' },
];

const plurals: Rule[] = [
  { pattern: /$/i, replacement: 's' },
  { pattern: /y$/i, replacement: 'ies' },
  // Add more plural rules as needed
];

const applyRules = (rules: Rule[], word: string): string => {
  let result: string = word;

  for (let i = 0; i <= rules.length - 1; i += 1) {
    const rule = rules[i];

    if (rule) {
      const applied = word.replace(rule.pattern, rule.replacement);

      if (applied !== word) {
        result = applied;
        break;
      }
    }
  }

  return result;
};

export const singularize = (word: string, inputIsKnownToBePlural = true): string => {
  const text = applyRules(singulars, word);

  if (inputIsKnownToBePlural) {
    return text;
  }

  const pluralForm = applyRules(plurals, word);
  const singularForm = applyRules(singulars, pluralForm);

  if (pluralForm !== word && `${word}s` !== pluralForm && singularForm === word && text !== word) {
    return word;
  }

  return text;
};

export const mergeVariantAndProductTitle = (productName: string, variantLabel: string) => {
  // Case 1: Variant label already includes the product name
  if (variantLabel.includes(productName)) {
    return variantLabel;
  }

  // Case 2: Product name already includes the variant label or the variant label is '0cl'
  if (productName.includes(variantLabel) || variantLabel === '0cl') {
    return productName;
  }

  // Case 3: Neither contains the other, so concatenate them
  return `${productName} ${variantLabel}`;
};
